import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import AdminLayout from "@/components/admin/AdminLayout";

export default function AdminUsers() {
    const { user: me } = useAuth();
    const [users, setUsers] = useState([]);
    const [query, setQuery] = useState("");
    const [error, setError] = useState("");

    const load = () => api.get("/admin/users").then(r => setUsers(r.data));
    useEffect(() => { load(); }, []);

    const toggleRole = async (u) => {
        if (u.id === me?.id) {
            alert("Você não pode rebaixar a si mesmo.");
            return;
        }
        const newRole = u.role === "admin" ? "user" : "admin";
        if (!window.confirm(`Alterar papel de ${u.name} para ${newRole}?`)) return;
        try {
            await api.patch(`/admin/users/${u.id}`, { role: newRole });
            await load();
        } catch (e) { setError(formatApiError(e)); }
    };

    const filtered = users.filter(u => {
        const q = query.toLowerCase();
        return !q || u.name.toLowerCase().includes(q) || u.email.toLowerCase().includes(q);
    });

    return (
        <AdminLayout eyebrow="Comunidade" title="Usuários">
            <div className="flex flex-wrap gap-3 mb-6">
                <input
                    data-testid="users-search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder="Buscar por nome ou e-mail..."
                    className="imq-input md:max-w-md"
                />
                <div className="ml-auto font-body text-sm text-[#5C5C5C] self-center">{filtered.length} usuário(s)</div>
            </div>

            {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 px-3 py-2 rounded-lg mb-4">{error}</div>}

            <div data-testid="users-table" className="bg-white border border-black/5 rounded-2xl overflow-hidden">
                <table className="w-full">
                    <thead className="bg-[#FAFAF7] text-left">
                        <tr>
                            <th className="overline text-[#5C5C5C] px-6 py-4">Nome</th>
                            <th className="overline text-[#5C5C5C] px-6 py-4">E-mail</th>
                            <th className="overline text-[#5C5C5C] px-6 py-4">Papel</th>
                            <th className="overline text-[#5C5C5C] px-6 py-4 hidden md:table-cell">Criado</th>
                            <th className="px-6 py-4 w-44 text-right"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map(u => (
                            <tr key={u.id} data-testid={`user-row-${u.id}`} className="border-t border-black/5">
                                <td className="px-6 py-4 font-display">{u.name}</td>
                                <td className="px-6 py-4 font-body text-sm text-[#5C5C5C]">{u.email}</td>
                                <td className="px-6 py-4">
                                    <span className={`text-[10px] tracking-widest uppercase font-display px-2.5 py-1 rounded-full ${u.role === "admin" ? "bg-[#1A1A1A] text-white" : "bg-[#F8F8F5] text-[#1A1A1A] border border-black/5"}`}>
                                        {u.role}
                                    </span>
                                </td>
                                <td className="px-6 py-4 font-body text-xs text-[#5C5C5C] hidden md:table-cell">
                                    {u.created_at ? new Date(u.created_at).toLocaleDateString("pt-BR") : "—"}
                                </td>
                                <td className="px-6 py-4 text-right">
                                    <button onClick={() => toggleRole(u)} data-testid={`user-toggle-${u.id}`} className="btn-ghost !py-1.5 !px-3 text-xs">
                                        {u.role === "admin" ? "Tornar usuário" : "Tornar admin"}
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {filtered.length === 0 && (
                            <tr><td colSpan={5} className="px-6 py-12 text-center font-body text-[#5C5C5C]">Nenhum usuário.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </AdminLayout>
    );
}
